import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {FormInput} from 'components/formInput';
import {TranslationMixin} from 'mixins/translationMixin';
import {WithCommonTranslations} from 'components/hocs/';
import {Button} from 'components/button';
import {HelperUtils} from 'services';
import './Table.css';

export const Table = WithCommonTranslations(
  class Table extends TranslationMixin(React.Component) {
    constructor(props) {
      super(props);
      this.state = {
        filterText: '',
        viewableEls: this.props.rows
      };
      this.handleChange = this.handleChange.bind(this);
      this.resetState = this.resetState.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
      return true;
    }

    dataColumns() {
      const columns = _.map(this.props.columns, function (colName, index) {
        return (
          <th key={index}>{colName.header}</th>
        );
      });
      return (
        <tr>{columns}</tr>
      );
    };

    resetState() {
      this.setState({filterText: ''});
    };

    containsText(displayValue) {
      const filterToLower = this.state.filterText.toLowerCase();
      if (filterToLower === '') {
        return true;
      }
      if (Array.isArray(displayValue)) {
        for (let i = 0; i < displayValue.length; i++) {
          const contains = displayValue[i].toString().toLowerCase().includes(filterToLower);
          if (contains) {
            return true;
          }
        }
        return false;
      } else {
        return displayValue && displayValue.toString().toLowerCase().includes(filterToLower);
      }
    }

    renderRows() {
      const _this = this;
      const {getRowClass} = this.props;
      let hasRows = false;
      const rowDisplay = _.map(_this.props.rows, function (row, id) {
        let rowContains = false;
        const values = _.map(_this.props.columns, function (col) {
          let displayValue = "";
          if (col.render){
            let jsx = col.render(row);
            displayValue = HelperUtils.getInnerText(jsx)
          } else {
            displayValue = row[col.accessor]
          }
          const searchField = _this.containsText(displayValue);

          if (searchField) {
            rowContains = true;
            hasRows = true;
          }

          if (col.render) {
            return (
              <td data-label={col.accessor} data-header={col.header}
                  key={col.accessor}>
                {col.render(row)}</td>
            );
          } else {
            if (Array.isArray(displayValue)) {
              return <td key={col.accessor} data-header={col.header}>{displayValue.map((description, index) => <div
                key={index}>{description}</div>)}</td>
            } else {
              return (
                <td data-label={col.accessor} data-header={col.header}
                    key={col.accessor}>{displayValue}</td>
              );
            }
          }
        });
        let rowClass = "";
        if (getRowClass){
          rowClass = getRowClass(row);
        }

        return (
          rowContains && <tr key={id} className={rowClass}>{values}</tr>
        );
      });
      if (hasRows) {
        return (
          rowDisplay
        );
      } else {
        return (
          this.noSearchResults()
        );
      }
    };

    noSearchResults() {
      const _this = this;
      return (
        <tr>
          <td colSpan={_this.props.columns.length}>{this.getTranslation('MESSAGE_NO_RESULTS_FOUND')}</td>
        </tr>
      );
    }

    handleChange(e) {
      this.setState({filterText: e.target.value});
    };

    render() {
      const filterText = this.state.filterText;
      const {onClick} = this.props;

      return (
        <div className="wrap">
          <div className="responsive-table">
            <div className="table-wrapper">
              <div className="d-flex flex-wrap">
                <div className="flex-grow-1 align-self-center">
                  {this.props.tableMessage && <div>{this.props.tableMessage}</div>}
                </div>

                <div className="d-flex">
                  <div className="data-search float-right align-self-end">
                    <div className="filterComponent">
                      <i className="fas fa-search"></i>
                      {filterText && <i onClick={this.resetState} className="fas fa-times-circle clearInput"></i>}
                      <FormInput name="filterData" id={this.props.filterId}
                                 value={filterText} maxLength={25}
                                 placeholder={this.getTranslation('LABEL_FILTER')}
                                 onChange={this.handleChange}/>
                    </div>
                  </div>
                </div>
              </div>

              {this.props.btnShowHide && <Button variant="link" type="button"
                                                 onClick={onClick} className="p-0 mb-3">{this.props.btnText}</Button>}

              <table className="responsive-table">
                <thead>
                {this.dataColumns()}
                </thead>
                <tbody>
                {this.renderRows()}
                </tbody>
              </table>

            </div>
          </div>
        </div>
      );
    }
  },
);

Table.propTypes = {
  filterId: PropTypes.string.isRequired, //id to give filter input
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array,
  tableMessage: PropTypes.node, //message to show above table. Need translation ID
  btnShowHide: PropTypes.bool, // to show or hide vin subscriptions
  btnText: PropTypes.any,
  getRowClass: PropTypes.func
};